
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const ProductDetailPage = lazy(() => import('../pages/products/ProductDetailPage'));
const ProjectsPage = lazy(() => import('../pages/projects/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactsPage = lazy(() => import('../pages/contacts/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/products', element: <ProductsPage /> },
  { path: '/products/:slug', element: <ProductDetailPage /> },
  { path: '/projects', element: <ProjectsPage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/contacts', element: <ContactsPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
